import { render, staticRenderFns } from "./KillfeedItemKill.vue?vue&type=template&id=793dcf9e&scoped=true&"
import script from "./KillfeedItemKill.vue?vue&type=script&lang=js&"
export * from "./KillfeedItemKill.vue?vue&type=script&lang=js&"
import style0 from "./KillfeedItemKill.vue?vue&type=style&index=0&id=793dcf9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "793dcf9e",
  null
  
)

export default component.exports